import React from 'react';
import { ComponentParams, ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';
import { TableFields } from './C41Table.types';

import { TableContainer } from '@ahc-digital/component-library';
import { GetTableModel } from './C41Table.service';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { translationClasses } from 'src/shared/TranslationClasses';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  TranslationOptionsParams,
} from 'src/shared/shared.types';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export interface C41TableProps {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams & {
    HeadlineTag?: string;
    ContentAlignment?: string;
    TableStyling?: string;
    PinFirstColumn?: string;
    CellAlignment?: string;
  } & DynamicPlaceholderParams &
    TranslationOptionsParams &
    AnchorTargetParams;
  fields?: {
    table?: TableFields;
  };
}

export const Default = (props?: C41TableProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <TableContainer
      {...GetTableModel(props)}
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
    />
  );
};
